import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Text } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';
import { sortPrescriptionParameters, PrescriptionValueUtils } from '@grandvisionhq/utils';

const PrescriptionTable = ({ parameters , left , right  })=>{
    const { getLabel  } = useIntl();
    const sortedParameterNames = sortPrescriptionParameters((parameters || []).map((p)=>p.name
    ));
    const rightEyeTitle = getLabel('products.glasses.rightEye');
    const leftEyeTitle = getLabel('products.glasses.leftEye');
    const paramLabels = parameters.reduce((acc, { name  })=>swcHelpers.objectSpread({}, acc, {
            [name]: getLabel(`products.glasses.prescription.${name}`)
        })
    , {});
    const parametersTitle = getLabel('products.glasses.configurator.prescription.parameters.title', {
        hideLabelKey: true
    });
    var ref, ref1;
    return /*#__PURE__*/ React.createElement("table", {
        className: "rxc-prescription-table",
        "aria-label": getLabel('products.glasses.configurator.footer.prescription.title')
    }, /*#__PURE__*/ React.createElement("thead", null, /*#__PURE__*/ React.createElement("tr", null, /*#__PURE__*/ React.createElement("th", {
        scope: "col"
    }, parametersTitle), /*#__PURE__*/ React.createElement("th", null, /*#__PURE__*/ React.createElement(Text, {
        component: "span",
        variant: "caption"
    }, rightEyeTitle)), /*#__PURE__*/ React.createElement("th", null, /*#__PURE__*/ React.createElement(Text, {
        component: "span",
        variant: "caption"
    }, leftEyeTitle)))), /*#__PURE__*/ React.createElement("tbody", null, sortedParameterNames === null || sortedParameterNames === void 0 ? void 0 : sortedParameterNames.map((param)=>/*#__PURE__*/ React.createElement("tr", {
            key: param
        }, /*#__PURE__*/ React.createElement("th", null, /*#__PURE__*/ React.createElement(Text, {
            component: "span",
            variant: "caption"
        }, paramLabels[param])), /*#__PURE__*/ React.createElement("td", null, /*#__PURE__*/ React.createElement(Text, {
            component: "span",
            variant: "caption-head"
        }, (ref = PrescriptionValueUtils.formatPrescriptionValue(param, right[param])) !== null && ref !== void 0 ? ref : '')), /*#__PURE__*/ React.createElement("td", null, /*#__PURE__*/ React.createElement(Text, {
            component: "span",
            variant: "caption-head"
        }, (ref1 = PrescriptionValueUtils.formatPrescriptionValue(param, left[param])) !== null && ref1 !== void 0 ? ref1 : '')))
    )));
};

export { PrescriptionTable };
//# sourceMappingURL=PrescriptionTable.js.map
